 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en-js":"lang-en-js","lang-lt-js":"lang-lt-js","lang-sv-js":"lang-sv-js"}[chunkId]||chunkId) + "." + {"chunk-00e0f36c":"8cda388e","chunk-0d7a0bfb":"e674b29f","chunk-219322be":"29f6339f","chunk-438472d7":"b5612a9f","chunk-470f0a5a":"3abe68ea","chunk-498166d2":"b424179a","chunk-49c52790":"2e52b3db","chunk-549fa66d":"c420e3ad","chunk-c073f344":"e5d8be4c","chunk-dfe299d8":"b7c95d4f","chunk-232bca90":"8247ec21","chunk-23dd0ebe":"b6121c9a","chunk-2548b3a8":"1460281d","chunk-2d0b381b":"7437b4b0","chunk-32572f6e":"3211a817","chunk-385111c2":"1be4b109","chunk-3c9f6780":"f7f1fdec","chunk-3f099074":"9c41768f","chunk-405f48a7":"22307a91","chunk-0f28b808":"6b57bdd9","chunk-49115233":"aea466a2","chunk-bb957460":"f8fda3a1","chunk-4a5f46a6":"f127ac0b","chunk-1ce62055":"122fe4d3","chunk-5c5a51a8":"b32d3b87","chunk-e22aaa64":"3c793fab","chunk-598833d5":"e288526c","chunk-71bd076c":"8f1b61da","chunk-7235df54":"ea1086db","chunk-7b171278":"3572ed6b","chunk-0f488032":"b066cf2c","chunk-141948cc":"06fb747d","chunk-2d0b2ed7":"3b79401d","chunk-172e3870":"50000163","chunk-2783d109":"78c6df99","chunk-15f1a830":"6fd87773","chunk-2adee926":"5c037785","chunk-05dde80e":"91fcca67","chunk-1322f252":"bc999686","chunk-5a0ffef1":"fc9d2344","chunk-87ffbe38":"0896d20d","chunk-8aea682c":"bf8e52fb","chunk-6aec368d":"0099ed11","chunk-2d0b37a5":"eac1fa54","chunk-2d210f7e":"a0c31043","chunk-5fde92a0":"ffa3b082","chunk-ac4d297e":"5a42b69b","chunk-6d614876":"b8fa8e82","chunk-701b9f1c":"419d3e78","chunk-2d224e86":"92e00364","chunk-79d1aae4":"1c6dd87a","chunk-af6da156":"3e06cb67","chunk-af99138e":"eeccc047","chunk-c465d8f0":"29fc66f8","chunk-7d2daf5b":"f4f726ac","chunk-da3f28c0":"854c2339","chunk-e86a95f2":"d2bdcb18","chunk-f791e3d8":"3eaee9c0","chunk-712b473b":"39bf0285","lang-en-js":"ef7e2caa","lang-lt-js":"bda829f5","lang-sv-js":"75142d2d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-00e0f36c":1,"chunk-0d7a0bfb":1,"chunk-219322be":1,"chunk-438472d7":1,"chunk-470f0a5a":1,"chunk-498166d2":1,"chunk-49c52790":1,"chunk-549fa66d":1,"chunk-c073f344":1,"chunk-dfe299d8":1,"chunk-232bca90":1,"chunk-23dd0ebe":1,"chunk-2548b3a8":1,"chunk-32572f6e":1,"chunk-385111c2":1,"chunk-3c9f6780":1,"chunk-3f099074":1,"chunk-405f48a7":1,"chunk-0f28b808":1,"chunk-49115233":1,"chunk-bb957460":1,"chunk-1ce62055":1,"chunk-5c5a51a8":1,"chunk-e22aaa64":1,"chunk-598833d5":1,"chunk-71bd076c":1,"chunk-7235df54":1,"chunk-0f488032":1,"chunk-141948cc":1,"chunk-2783d109":1,"chunk-15f1a830":1,"chunk-2adee926":1,"chunk-05dde80e":1,"chunk-1322f252":1,"chunk-5a0ffef1":1,"chunk-87ffbe38":1,"chunk-8aea682c":1,"chunk-6aec368d":1,"chunk-5fde92a0":1,"chunk-ac4d297e":1,"chunk-6d614876":1,"chunk-701b9f1c":1,"chunk-af6da156":1,"chunk-af99138e":1,"chunk-c465d8f0":1,"chunk-7d2daf5b":1,"chunk-da3f28c0":1,"chunk-e86a95f2":1,"chunk-f791e3d8":1,"chunk-712b473b":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en-js":"lang-en-js","lang-lt-js":"lang-lt-js","lang-sv-js":"lang-sv-js"}[chunkId]||chunkId) + "." + {"chunk-00e0f36c":"d6329513","chunk-0d7a0bfb":"f6f7544d","chunk-219322be":"aeeeef60","chunk-438472d7":"9196ef73","chunk-470f0a5a":"9196ef73","chunk-498166d2":"9196ef73","chunk-49c52790":"9196ef73","chunk-549fa66d":"0e0c763f","chunk-c073f344":"c33426be","chunk-dfe299d8":"74c4f697","chunk-232bca90":"8445e5cf","chunk-23dd0ebe":"132c969d","chunk-2548b3a8":"d6329513","chunk-2d0b381b":"31d6cfe0","chunk-32572f6e":"80cb97c4","chunk-385111c2":"b8a90f96","chunk-3c9f6780":"f6f7544d","chunk-3f099074":"884b8d9f","chunk-405f48a7":"93c78f2f","chunk-0f28b808":"c686d0a3","chunk-49115233":"dbadae5b","chunk-bb957460":"396b1795","chunk-4a5f46a6":"31d6cfe0","chunk-1ce62055":"bf017553","chunk-5c5a51a8":"d3f07ac9","chunk-e22aaa64":"d3f07ac9","chunk-598833d5":"c19e319e","chunk-71bd076c":"9ce59ce5","chunk-7235df54":"01dffad3","chunk-7b171278":"31d6cfe0","chunk-0f488032":"aac88883","chunk-141948cc":"8445e5cf","chunk-2d0b2ed7":"31d6cfe0","chunk-172e3870":"31d6cfe0","chunk-2783d109":"f663a350","chunk-15f1a830":"28dc9954","chunk-2adee926":"61aaafc6","chunk-05dde80e":"8c36e402","chunk-1322f252":"f78290d0","chunk-5a0ffef1":"d8efd9a5","chunk-87ffbe38":"3823eeed","chunk-8aea682c":"0c40dedd","chunk-6aec368d":"a4e5e3fb","chunk-2d0b37a5":"31d6cfe0","chunk-2d210f7e":"31d6cfe0","chunk-5fde92a0":"28dc9954","chunk-ac4d297e":"3979f8d3","chunk-6d614876":"a2f735c2","chunk-701b9f1c":"8445e5cf","chunk-2d224e86":"31d6cfe0","chunk-79d1aae4":"31d6cfe0","chunk-af6da156":"f6f7544d","chunk-af99138e":"f6f7544d","chunk-c465d8f0":"cc61ed20","chunk-7d2daf5b":"d6329513","chunk-da3f28c0":"b0798942","chunk-e86a95f2":"b0798942","chunk-f791e3d8":"159698d8","chunk-712b473b":"7c7e44ec","lang-en-js":"31d6cfe0","lang-lt-js":"31d6cfe0","lang-sv-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
